import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BrandLogo from "../BrandLogo";

export const DashboardFooter = ({ hideLegalLinks = false } = {}) => {
  const { t } = useTranslation();
  return (
    <footer className="py-8 px-6 mt-12" style={{ background: "#f8fafc" }}>
      <div className="max-w-4xl mx-auto">
        <div className="h-px mb-6" style={{ background: "#e2e8f0" }} />
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <BrandLogo variant="footer" />
          </div>
          <div className="flex flex-col md:flex-row items-center gap-4 text-sm" style={{ color: "#64748b" }}>
            {!hideLegalLinks && (
              <>
                <Link
                  to="/privacy"
                  className="transition-colors hover:underline"
                  style={{ color: "#64748b" }}
                  data-testid="dashboard-footer-privacy"
                >
                  {t("common.privacyPolicy")}
                </Link>
                <Link
                  to="/disclaimer"
                  className="transition-colors hover:underline"
                  style={{ color: "#64748b" }}
                  data-testid="dashboard-footer-disclaimer"
                >
                  {t("common.medicalDisclaimer")}
                </Link>
              </>
            )}
            <a
              href={"mailto:support@kilpn\u00e4\u00e4rmekliinik.ee"}
              className="transition-colors hover:underline"
              style={{ color: "#64748b" }}
            >
              {"support@kilpn\u00e4\u00e4rmekliinik.ee"}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
